import React from "react";
import {Play} from "../../assets/files";
import styles from "./VideoPlayer.module.css";

interface PauseOverlayProps {
    play: boolean;
    isEventNotStartedVisible: boolean;
    onToggle: () => void;
}

const PauseOverlay: React.FC<PauseOverlayProps> = ({
    play,
    isEventNotStartedVisible,
    onToggle,
}) => {
    if (play || isEventNotStartedVisible) return null;
    return (
        <div className={styles.pauseOverlay} onClick={onToggle}>
            <Play />
        </div>
    );
};

export default PauseOverlay;
